// AlpineJS
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

// LazySizes
import 'lazysizes'

// Google Maps
import { Loader } from "@googlemaps/js-api-loader"

const mapElement = document.querySelector('.js-google-map')
if (mapElement) {
  const apiKey = mapElement.dataset.mapToken
  const lat = parseFloat(mapElement.dataset.lat)
  const lng = parseFloat(mapElement.dataset.lng)
  const zoom = parseFloat(mapElement.dataset.zoom)

  const loader = new Loader({
    apiKey,
    version: "weekly",
  })

  loader.load().then(() => {
    const map = new google.maps.Map(mapElement, {
      center: { lat, lng },
      zoom,
    })

    const marker = new google.maps.Marker({
      position: { lat, lng },
      map: map,
    })
  })
}
